Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};
Greenmile.PanelBuilder.Fields = Greenmile.PanelBuilder.Fields || {};

Greenmile.PanelBuilder.Fields.RuleSelectFieldList = (function () {

    function RuleSelectFieldList (entity) {

        Greenmile.PanelBuilder.SelectFieldList.apply(this, arguments);

        var defaultTypes = ['PICKLIST', 'DISTANCE', 'CHECKBOX', 'INTEGER', 'SECONDS', 'TEXT', 'DATE_TIME', 'DECIMAL'];

        this.beforeCreateList = function () {
            this.reduceToFieldTypes(defaultTypes);
        };
    };

    return RuleSelectFieldList;

}());